import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './ServicePackages.module.scss';
import ServicePackageItem from "./ServicePackageItem/ServicePackageItem";
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";
import ModalMoreInfoPackage from "./ModalMoreInfoPackage/ModalMoreInfoPackage";

const ServicePackages = ({customPackage, servicePackages}) => {
    const [isModalMoreInfoPackageOpen, setIsModalMoreInfoPackageOpen] = useState(false);

    const dispatch = useDispatch();
    const {service_package} = useSelector(state => state.stepperInfo);

    const handleSelectPackage = (id, name, price, services) => {
        dispatch(stepperInfoActions.setServicePackage({id, name, price, services}));

        // if user select another service package, then delete the data from the previous one
        dispatch(stepperInfoActions.setCountBathrooms(null));
        dispatch(stepperInfoActions.setCountRooms(null));
        dispatch(stepperInfoActions.setTypeCleaning('Генеральне'));
        dispatch(stepperInfoActions.setTypeBuilding('Квартира'));
    }

    // Guard against undefined/empty so we never read `.length`/`.slice` of undefined.
    const safePackages = Array.isArray(servicePackages) ? servicePackages : [];
    const safeCustomPackage = customPackage || {};

    if (safePackages.length === 0) {
        return null;
    }

    return (
        <>
            <div className={styles.servicePackages_wrapper}>
                <div className={styles.servicePackages_wrapper_defaultPackages}>
                    {safePackages.slice(0, safePackages.length - 1)?.map((item, index) =>
                        <ServicePackageItem
                            handleSelectPackage={handleSelectPackage}
                            setIsModalMoreInfoPackageOpen={setIsModalMoreInfoPackageOpen}
                            key={index}
                            id={item.id}
                            price={item.price}
                            name={item.name}
                            services={item.service_list}
                        />)}
                </div>

                {Object.keys(safeCustomPackage)?.length > 0 &&
                    <div
                        onClick={() =>
                            handleSelectPackage(safeCustomPackage?.id, safeCustomPackage?.name, +safeCustomPackage?.price, [])
                        }
                        className={`${styles.servicePackages_wrapper_customPackage} 
                    ${(service_package.name === 'Індивідуальний пакет') ? styles.selected : ''}`}
                    >
                        <h2>{safeCustomPackage?.name}</h2>
                        <p>Від ₴{+safeCustomPackage?.price}</p>
                    </div>}
            </div>

            {isModalMoreInfoPackageOpen &&
                <ModalMoreInfoPackage setIsModalMoreInfoPackageOpen={setIsModalMoreInfoPackageOpen}/>}
        </>
    );
};

export default ServicePackages;
